import { render, staticRenderFns } from "./EditActivity.vue?vue&type=template&id=8bc148c4&scoped=true&"
import script from "./EditActivity.vue?vue&type=script&lang=js&"
export * from "./EditActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc148c4",
  null
  
)

export default component.exports